import { useState } from "react";
import { PencilSimple, Trash } from "@phosphor-icons/react";
import UniversalPickerModal from "shared/components/UniversalPickerModal/UniversalPickerModal";

export interface ContactData {
  id: number;
  firstName: string;
  lastName: string;
  email?: string;
  phone_mobile?: string;
}

export interface ContactLinkCellProps {
  contact: ContactData | null | undefined;
  onUpdate: (contactData: ContactData | null) => void;
  emptyLabel: string;
  pickerTitle: string;
}

export const ContactLinkCell = ({
  contact,
  onUpdate,
  emptyLabel,
  pickerTitle,
}: ContactLinkCellProps) => {
  const [isPickerOpen, setIsPickerOpen] = useState(false);

  return (
    <>
      <div className="flex items-center justify-between group">
        <button
          onClick={() => setIsPickerOpen(true)}
          className="text-sm text-left hover:underline"
        >
          {contact ? (
            <span className="text-neutral-primary">
              {contact.firstName} {contact.lastName}
            </span>
          ) : (
            <span className="text-neutral-primary/60 italic">{emptyLabel}</span>
          )}
        </button>
        <div className="flex items-center gap-1">
          {contact && (
            <button
              onClick={() => onUpdate(null)}
              className="opacity-0 group-hover:opacity-100 p-1 text-red-500 hover:text-red-600 hover:bg-red-50 rounded-sm transition-opacity"
              title="Ontkoppelen"
            >
              <Trash size={14} />
            </button>
          )}
          <button
            onClick={() => setIsPickerOpen(true)}
            className="opacity-0 group-hover:opacity-100 ml-1 p-1 hover:bg-gray-100 rounded-sm transition-opacity"
            title="Bewerken"
          >
            <PencilSimple size={14} />
          </button>
        </div>
      </div>

      <UniversalPickerModal
        isOpen={isPickerOpen}
        mode="reporter"
        title={pickerTitle}
        onClose={() => setIsPickerOpen(false)}
        onConfirm={(selected: any) => {
          if (selected && selected.id) {
            onUpdate({
              id: Number(selected.id),
              firstName: selected.firstName || "",
              lastName: selected.lastName || "",
              email: selected.email || undefined,
              phone_mobile:
                selected.phone_mobile || selected.phoneMobile || undefined,
            });
          }
          setIsPickerOpen(false);
        }}
        config={{
          searchPlaceholder: "Zoek op naam, bedrijf of tag...",
          defaultValue: contact ? { id: String(contact.id) } : undefined,
        }}
      />
    </>
  );
};

export default ContactLinkCell;
